module.exports = __webpack_public_path__ + "static/media/api_object_short.6e29fde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/api_object_short.png
// module id = 529
// module chunks = 0